import { DEFAULT_GOOD_VIBES_TIME_FRAME, GoodVibesTimeFrameSchema } from "@domains/good-vibes/shared/goodVibesTimeFrame.ts";
import { DEFAULT_GOOD_VIBES_VISIBILITY, GoodVibesVisibilitySchema } from "@domains/good-vibes/shared/goodVibesVisibility.ts";
import { DEFAULT_REPORTING_SCOPE, REPORTING_SCOPES, type ReportingScope } from "@packages/core/organization/scope.ts";
import { parseAsStringEnum, parseAsStringLiteral, useQueryStates } from "nuqs";

export const GOOD_VIBES_SCOPE_QUERY_KEY = "good-vibes-scope";
export const GOOD_VIBES_PERIOD_QUERY_KEY = "good-vibes-period";
export const GOOD_VIBES_VISIBILITY_QUERY_KEY = "good-vibes-visibility";

export const GOOD_VIBES_FILTER_QUERY_KEYS = [GOOD_VIBES_SCOPE_QUERY_KEY, GOOD_VIBES_PERIOD_QUERY_KEY, GOOD_VIBES_VISIBILITY_QUERY_KEY] as const;

const QUERY_STATE_OPTIONS = { history: "replace" as const, clearOnDefault: true, shallow: false };

const goodVibesFilterParsers = {
    scope: parseAsStringEnum<ReportingScope>([...REPORTING_SCOPES]).withDefault(DEFAULT_REPORTING_SCOPE),
    timeFrame: parseAsStringLiteral(GoodVibesTimeFrameSchema.options).withDefault(DEFAULT_GOOD_VIBES_TIME_FRAME),
    visibility: parseAsStringLiteral(GoodVibesVisibilitySchema.options).withDefault(DEFAULT_GOOD_VIBES_VISIBILITY)
};

const GOOD_VIBES_FILTER_URL_KEYS = {
    scope: GOOD_VIBES_SCOPE_QUERY_KEY,
    timeFrame: GOOD_VIBES_PERIOD_QUERY_KEY,
    visibility: GOOD_VIBES_VISIBILITY_QUERY_KEY
};

export function useGoodVibesFilters() {
    return useQueryStates(goodVibesFilterParsers, { ...QUERY_STATE_OPTIONS, urlKeys: GOOD_VIBES_FILTER_URL_KEYS });
}
